'use strict'

const bp = {
  tablet: 768,
  desktop: 1024
}
const headerSize = {
  mobile: 70,
  tablet: 70,
  desktop: 119
}

const stickyNavSize = 138

const SELECTOR_ANCHOR_LINK = 'a[href^="#"]'
const SELECTOR_STICKY_NAV = '.label-services'

import { debounce } from 'lodash'

export default {
  /**
   * @description Initialise adjustScrollWithHash
   * @returns {undefined}
   */
  init() {
    if (document.querySelector(SELECTOR_STICKY_NAV)) {
      for (const value in headerSize) {
        headerSize[value] += stickyNavSize
      }
    }
    this.bind()
    if (location.hash) {
      this.triggerHashChange()
    }
  },
  
  /**
   * @description listen to hashchange and click on anchor link
   * @returns {undefined}
   */
  bind() {
    window.addEventListener('hashchange', this.adjustScroll.bind(this), false)
    document.querySelectorAll(SELECTOR_ANCHOR_LINK).bindEvent('click', this.triggerHashChange)
  },
  
  /**
   * @description adjust scrollTop after anchor scroll
   * @returns {undefined} none
   */
  adjustScroll() {
    window.scrollBy(0, -headerSize[this.getbp()])
  },
  
  /**
   * @description determine and return breakpoint
   * @returns {string} breakpoint
   */
  getbp() {
    const width = window.screen.width
    let breakpoint = 'desktop'
    
    for (let i in bp) {
      if (width < bp[i]) {
        breakpoint = i
      }
    }
    
    return breakpoint
  },
  
  /**
   * @description adjust scrollTop after anchor scroll
   * @returns {undefined} none
   */
  triggerHashChange(e) {
    if ((e && e.currentTarget.getAttribute('href') !== location.hash)) {
      return
    }
    const debounceScroll = debounce(() => {
      window.removeEventListener('scroll', debounceScroll)
      window.dispatchEvent(new Event('hashchange'))
    }, 50).bind(this)
    window.addEventListener('scroll', debounceScroll)
  }
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/utils/adjustScrollWithHash.js